export default {
  getAccessToken(state) {
    return state.accessToken;
  },
  getUserData: (state) => state.userData,
  getUpdateInfo: (state) => state.updateInfo,
  getDeviceInfo: (state) => state.deviceInfo,
  getLoginInfo: (state) => state.loginInfo,
  getIsSeller: (state) => state.userData.isSeller,
  getUserPosition: (state) => state.position,
  getCoupons: (state) => state.coupons,
  getPoints: (state) => state.points,
  getStores: (state) => state.stores,
  getJoinType: (state) => state.userData.joinType,
  access: (state) => state.access,
  getIsOnAlert: (state) => state.isOnAlert
};
